import FileModel, { FileStates } from "./FileModel";
import { assign } from "./common";

// TODO: make url a getter?

const dummyLink = document.createElement("a");

function ext(path) {
  return path.substring(path.lastIndexOf("."));
}

function randomHash(url) {
  const len = 6;
  dummyLink.href = url;
  dummyLink.search = "?" + Math.random().toFixed(len).substring(2);
  return dummyLink.href;
}

const ImageModel = FileModel.extend(
  /** @lends ImageModel.prototype */
  {
    /**
     * Image model specialization
     * @param {File} file
     * @param {object} opts
     * @param {object} opts.previewName - url is taken from `data.cache[id][this.opts.previewName].http`
     * @constructs
     * @extends FileModel
     */
    constructor(file, opts) {
      FileModel.call(this, file, opts);
      this.url = null;
      if(this.isStatic()) {

        /** server-side id used in ajax */
        this.sid = file.id;

        this.setUrl(file.url);
      }
    },

    /**
     * @protected
     */
    handleUploadSuccess(data) {
      try {
        const id = data.id[0];
        this.sid = id;

        /**
         * complete data received in server response
         * @type {object}
         */
        this.serverData = data.cache[id];

        const url = this.serverData[this.opts.previewName].http;
        this.setUrl(url);

        this.file = {
          id,
          url: this.serverData.thumbs.http,
          full: this.serverData.pics.http,
          original: this.serverData.original.http,
          data: this.serverData.original.dbentry,
          width: this.serverData.thumbs.width,
          height: this.serverData.thumbs.height,
          fullWidth: this.serverData.pics.width,
          fullHeight: this.serverData.pics.height
        };

        this.setState(FileStates.OK);
      } catch(e) {
        // wrongly formatted data sent from server
        this.handleUploadError(e);
      }
    },

    /**
     * Set thumbnail url or reload current image
     * @param {string} [url] - url to set or nothing to reload
     * @protected
     */
    setUrl(url) {
      if(url === undefined) url = this.url; // act as reload if no url provided
      this.emit("url", { url: this.url = randomHash(url) });
    },

    getDefaultOptions() {
      return assign(FileModel.prototype.getDefaultOptions.call(this), {});
    },

    getMIME() {
      return this.isStatic() ? "image/" + ext(this.file.url) : FileModel.prototype.getMIME.call(this);
    },

    /**
     * Rotate the image
     * @param {boolean} isRight - rotate clockwise
     */
    rotate(isRight) {
      if(this.state !== FileStates.OK) {
          console.warn("Rotating file with state other than OK");
          return;
      }
      this.setState(FileStates.PENDING);
      this.opts.adapter.rotateImage(this, isRight, (error, payload) => {
        if(error) {
          // TODO: warn
          console.error("Rotating file failed", error);
          this.emit("rotate_failed", { error });
        } else {
          this.setUrl();
          this.emit("rotate");
        }
        this.setState(FileStates.OK);
      });

      if(this.isStatic()) {
        var tmp;
        tmp = this.file.width;
        this.file.width = this.file.height;
        this.file.height = tmp;
        tmp = this.file.fullWidth;
        this.file.fullWidth = this.file.fullHeight;
        this.file.fullHeight = tmp;
      }
    }
  });

export default ImageModel;
